import React, { useState } from "react";
import { FaSpinner, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { PiPlusBold } from "react-icons/pi";
import { toast } from "react-toastify";
import { pushNotifyDriver } from "../../redux/slices/pushSlice";
import { fetchDrivers } from "../../redux/slices/driverSlice";

export default function ModalDriverPromotion({
  selectedDriverIds,
  clearSelectedDriverIds,
}) {
  const [showModal, setShowModal] = useState(false);
  const [body, setBody] = useState(""); // State for the body property
  const status = useSelector((state) => state.push?.driverStatus);

  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const pushNote = {
        driver_id: selectedDriverIds,
        title: "Capfields Evolve",
        // body: "Your account has been funded.",
        body: body,
        click: "PROMOTION",
      };

      const res = await dispatch(pushNotifyDriver(pushNote));

      clearSelectedDriverIds();
      setBody("");
      await dispatch(fetchDrivers());
      toast.success(res.payload.message);
    } catch (error) {
      console.error(error);
    }
    setShowModal(false);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setShowModal(true)}
        className="flex gap-[8px] bg-[#1F7BF4] text-white items-center py-2 px-4 text-[14px] hover:shadow-lg rounded-[8px] font-medium"
      >
        <PiPlusBold className=" text-lg font-extrabold" />
        Send Promotion
      </button>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-5xl">
              <div className="border-0 rounded-lg p-6 shadow-lg relative flex flex-col bg-white outline-none focus:outline-none">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center"
                >
                  <FaTimes className="text-gray-300 text-xl" />
                  <span className="sr-only">Close modal</span>
                </button>
                <div className=" text-center">
                  <h1 className="text-2xl text-gray-800 text-center font-medium mb-4">
                    Send Promotion
                  </h1>
                </div>
                <div className="flex items-center px-8 py-4 gap-6">
                  <div className="flex flex-col gap-4">
                
                    <div className="flex flex-col gap-1">
                      <label
                        htmlFor="body"
                        className="text-[14px] text-center text-[#4D5464] font-medium tracking-[0.07px]"
                      >
                        Message
                      </label>
                      <div className="flex items-center">
                        <textarea
                          name="body"
                          id="body"
                          value={body}
                          onChange={(e) => setBody(e.target.value)} // Set body state on change
                          placeholder="Type message here..."
                          className="pl-[12px] text-[#333843] p-2 rounded-lg text-[14px] bg-[#F9F9FC] w-full border-2 border-[#E0E2E7] resize-none h-24"
                        />
                      </div>
                    </div>

                    <div className="flex mt-6 gap-4 justify-center">
                      <button
                        onClick={() => setShowModal(false)}
                        className="text-sm text-blue-500 font-semibold bg-blue-100 py-2 px-4 rounded-lg"
                      >
                        Cancel
                      </button>
                      <button
                        className="flex gap-1 rounded-lg items-center bg-blue-600 text-white py-2 px-4"
                        disabled={status === "loading"}
                        onClick={handleSubmit}
                      >
                        {status === "loading" ? (
                          <>
                            <FaSpinner className="animate-spin" />
                            <p className="text-sm font-semibold whitespace-nowrap">
                              Adding ...
                            </p>
                          </>
                        ) : (
                          <>
                            <PiPlusBold className="w-4 h-4" />
                            <p className="text-sm font-semibold whitespace-nowrap">
                              Send Promotion
                            </p>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
